import { Component, Vue } from 'vue-property-decorator';
import IconText from '../shared/iconText.vue';
import LoginInformation from '../../types/login_information';
import { Getter } from 'vuex-class';
import { ViewerContext } from '../../types/viewer_context';

@Component({ components: { IconText } })
export default class MainNavigation extends Vue {
  @Getter public loginInformation!: LoginInformation;
  @Getter public viewerContext!: ViewerContext;

  public get isAdminAndHasSeeingDifferentInstitution(): boolean {
    return (
      this.loginInformation.admin &&
      this.loginInformation.institution.id != this.viewerContext.institutionId
    );
  }

  public resetViewer(): void {
    this.setViewer(null);
  }

  private setViewer(viewer: { id: string; name: string; type: string } | null) {
    this.$store.commit('setViewAs', viewer);
  }
}
